function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", {
  id: "defs2"
}, /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath4534"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,131.523 H 131.523 V 0 H 0 Z",
  id: "path4532"
})), /*#__PURE__*/React.createElement("clipPath", {
  clipPathUnits: "userSpaceOnUse",
  id: "clipPath4563"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 0,131.523 H 131.523 V 0 H 0 Z",
  id: "path4561"
})));

var SvgTurnOff = function SvgTurnOff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg8",
    viewBox: "0 0 46.398285 46.398251",
    height: "46.398251mm",
    width: "46.398285mm",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-87.717713,-124.12994)",
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4555",
    transform: "matrix(0.35277777,0,0,-0.35277777,87.717713,170.52833)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4557"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4559",
    clipPath: "url(#clipPath4563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4565",
    transform: "translate(120.6547,19.6984)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c 0,-4.87 -3.961,-8.831 -8.83,-8.831 h -92.127 c -4.869,0 -8.83,3.961 -8.83,8.831 v 92.126 c 0,4.87 3.961,8.831 8.83,8.831 H -8.83 c 4.869,0 8.83,-3.961 8.83,-8.831 z m -8.83,111.825 h -92.127 c -10.861,0 -19.698,-8.837 -19.698,-19.699 V 0 c 0,-10.862 8.837,-19.698 19.698,-19.698 H -8.83 c 10.86,0 19.698,8.836 19.698,19.698 v 92.126 c 0,10.862 -8.838,19.699 -19.698,19.699 m -50.222,-77.838 -7.823,7.823 -22.7,-22.701 v 27.454 h -11.064 V 8.758 c 0,-4.654 3.787,-8.44 8.44,-8.44 h 37.805 v 11.064 h -27.263 z m 41.464,57.822 H -55.394 V 80.744 h 27.264 l -22.605,-22.605 7.822,-7.822 22.7,22.7 V 45.563 h 11.065 v 37.806 c 0,4.653 -3.787,8.44 -8.44,8.44",
    style: {
      fill: "#626060",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path4567"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTurnOff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/turn_off.78902b37.svg";
export { ForwardRef as ReactComponent };